import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom"

import { Box } from "@mui/material"
import { Videos, ChannelCard } from './'
import { fetchFromApi } from '../utils/fetchFromApi'
import zIndex from '@mui/material/styles/zIndex'

function ChannelDetail() {
  const [channelDetail, setChannelDetail] = useState(null)
  const [videos, setVideos] = useState([])

  const { id } = useParams()


  useEffect(() => {
    fetchFromApi(`channels?part=snippet&id=${id}`)
      .then(data => setChannelDetail(data?.items[0]))

    fetchFromApi(`search?channelId=${id}&part=snippet&order=date`)
      .then(data => setVideos(data?.items))
  }, [id])
  return (
    <Box minHeight="95vh" style={{ backgroundColor: "black" }}>
      <Box>
        <div
          style={{
            zIndex: 10,
            height: "300px",
            background: 'rgb(2,0,36)',
            // background: 'linear - gradient(304deg, rgba(2, 0, 36, 1) 17 %, rgba(140, 140, 195, 1) 89 %)',
          }}

        />
        <ChannelCard channelDetail={channelDetail} marginTop="-110px" />

        <Box display="flex" p="2">
          <Box sx={{ mr: { sm: "100px" } }}></Box>
          <Videos Videos={videos}></Videos>

        </Box>
      </Box>

    </ Box>
  )
}

export default ChannelDetail